import React from "react";
import { Route, Switch } from "react-router-dom";
import SectionD from "../pages/SectionD/SectionD";
import SectionPage from "../pages/Sections/SectionPage";
import TestPage from "../pages/TestPage/TestPage";
import TestContextProvider from "../contexts/TestContext";

const TestRoutes = () => {
	return (
		<TestContextProvider>
			<Switch>
				<Route exact path="/test/sections" component={SectionPage} />
				<Route exact path="/test/sectionD" component={SectionD} />
				<Route exact path="/test/section/:id" component={TestPage} />
			</Switch>
		</TestContextProvider>
	);
};

export default TestRoutes;
